interface Breadcrumb {
  label: string
  path?: string
}

export const BreadcrumbVariant = {
  default: 'default',
  condensed: 'condensed',
} as const

export interface ContextState {
  breadcrumbs: Breadcrumb[]
  variant: (typeof BreadcrumbVariant)[keyof typeof BreadcrumbVariant]
}

export type Action =
  | { type: 'setBreadcrumbs'; payload: Breadcrumb[] }
  | { type: 'setPageHeader'; payload: ContextState }
